import CommonFilterStore from '../CommonFilter/Store';

class CompetencyFilterStore extends CommonFilterStore {
  getFilterValues(): string[] {
    return this._filters.competencies.map((d) => d.payload.name.text);
  }
}

export default CompetencyFilterStore;
